import React from 'react'
import { Link } from 'react-router-dom'

export default function Categories() {
  return (
    <div className='row pt-0'>
    <div className='col-5 categories'>
        Categories
    </div>
    <div className='col-7 marginTopHr'>
        <hr/>
    </div>
    <div>
        <div className='row text-center'>
            <div className='col'>
                <Link to={`/recipes/appetizer`} style={{textDecoration: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="58px" viewBox="0 0 66 58" enableBackground="new 0 0 66 58">
<g>
<path fill="#E35640" d="M44.521,25.934c2.712,0,4.931-2.218,4.931-4.946c0-2.716-2.219-4.933-4.931-4.933
c-2.714,0-4.931,2.217-4.931,4.933C39.59,23.715,41.807,25.934,44.521,25.934z M44.608,23.419c-0.513,0-0.938-0.426-0.938-0.957
c0-0.528,0.425-0.958,0.938-0.958c0.542,0,0.976,0.43,0.976,0.958C45.584,22.993,45.15,23.419,44.608,23.419z M44.521,18.071
c1.601,0,2.93,1.312,2.93,2.916c0,0.155-0.02,0.307-0.054,0.458c-0.439-1.133-1.502-1.953-2.788-1.953
c-1.42,0-2.593,0.997-2.903,2.316c-0.066-0.27-0.115-0.533-0.115-0.822C41.59,19.383,42.917,18.071,44.521,18.071z"></path>
<path fill="#E35640" d="M61.957,23.151c-0.203-0.516-0.816-0.739-1.308-0.52l-8.302,3.675c1.002-1.513,1.622-3.346,1.622-5.32
c0-5.203-4.23-9.452-9.449-9.452c-1.367,0-2.636,0.299-3.796,0.801l4.935-7.211c0.321-0.455,0.179-1.087-0.271-1.395
c-0.454-0.316-1.092-0.199-1.391,0.259L18.51,41.247L4.604,47.375c-0.534,0.211-0.739,0.812-0.538,1.311
c0.188,0.374,0.558,0.612,0.941,0.612c0.123,0,0.247-0.025,0.403-0.077l10.932-4.832L9.37,54.543
c-0.283,0.449-0.178,1.089,0.272,1.409c0.192,0.106,0.374,0.157,0.586,0.157c0.289,0,0.611-0.137,0.824-0.431l8.771-12.828
l41.633-18.374C61.951,24.256,62.197,23.664,61.957,23.151z M51.969,20.987c0,4.104-3.341,7.446-7.448,7.446
c-4.105,0-7.449-3.342-7.449-7.446c0-4.093,3.344-7.434,7.449-7.434C48.628,13.554,51.969,16.895,51.969,20.987z M35.092,20.566
c-0.007,0.146-0.021,0.29-0.021,0.421c0,4.769,3.522,8.707,8.096,9.351l-21.174,9.348L35.092,20.566z"></path>
</g>
                </svg>
                <span className='categoryName'>
                    APPETIZER
                </span>
                </Link>
            </div>
            <div className='col'>
            <Link to={`/recipes/meat`} style={{textDecoration: 'none'}}>
                <svg style={{position: 'relative', bottom: '10px'}} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="58px" viewBox="0 0 66 58" enableBackground="new 0 0 66 58">
<g>
<path fill="#E35640" d="M34.119,42.677c0.179,0.182,0.452,0.311,0.727,0.311c0.225,0,0.491-0.122,0.703-0.292
c0.397-0.386,0.408-1.035,0.02-1.432l-3.142-3.224c-0.388-0.399-0.998-0.408-1.396-0.021c-0.402,0.388-0.432,1.035-0.021,1.432
L34.119,42.677z"></path>
<path fill="#E35640" d="M38.25,46.916c0.176,0.22,0.45,0.312,0.723,0.312c0.229,0,0.494-0.085,0.704-0.294
c0.399-0.387,0.407-1.035,0.021-1.432l-1.023-1.013c-0.386-0.432-1.035-0.441-1.431-0.052c-0.397,0.412-0.405,1.031-0.02,1.428
L38.25,46.916z"></path>
<path fill="#E35640" d="M27.872,36.262c0.215,0.183,0.45,0.276,0.724,0.276c0.266,0,0.518-0.088,0.706-0.257
c0.397-0.387,0.405-1.035,0.02-1.433l-3.104-3.226c-0.388-0.397-1.035-0.406-1.433-0.02c-0.396,0.387-0.405,1.035-0.018,1.433
L27.872,36.262z"></path>
<path fill="#E35640" d="M46.245,45.026c0.213,0.213,0.446,0.302,0.714,0.302c0.271,0,0.503-0.089,0.719-0.306
c0.389-0.392,0.389-1.041-0.004-1.431l-2.519-2.467c-0.394-0.392-1.03-0.389-1.429,0.003c-0.393,0.394-0.391,1.003,0.004,1.394
L46.245,45.026z"></path>
<path fill="#E35640" d="M40.572,39.383c0.209,0.205,0.446,0.3,0.715,0.3c0.268,0,0.503-0.097,0.718-0.304
c0.39-0.393,0.39-1.042-0.004-1.433l-3.193-3.139c-0.394-0.392-1.005-0.389-1.398,0.003c-0.392,0.394-0.388,1.042,0.005,1.433
L40.572,39.383z"></path>
<path fill="#E35640" d="M34.226,33.065c0.213,0.214,0.443,0.301,0.714,0.301c0.27,0,0.501-0.089,0.716-0.304
c0.392-0.394,0.39-1.04-0.002-1.433l-3.17-3.14c-0.417-0.391-1.026-0.387-1.417,0.004c-0.392,0.393-0.392,1.042,0.004,1.433
L34.226,33.065z"></path>
<path fill="#E35640" d="M41.365,30.352c0.211,0.173,0.438,0.292,0.704,0.292c0.272,0,0.511-0.129,0.727-0.313
c0.385-0.398,0.375-1.047-0.021-1.432l-3.237-3.097c-0.395-0.385-1.012-0.377-1.42,0.021c-0.372,0.398-0.355,1.047,0.044,1.433
L41.365,30.352z"></path>
<path fill="#E35640" d="M51.008,38.249c-0.385,0.396-0.375,1.046,0.023,1.432l0.772,0.749c0.175,0.169,0.438,0.264,0.704,0.264
c0.24,0,0.512-0.103,0.724-0.285c0.388-0.397,0.378-1.046-0.022-1.432l-0.779-0.75C52.019,37.843,51.394,37.851,51.008,38.249z"></path>
<path fill="#E35640" d="M47.795,36.564c0.215,0.188,0.445,0.272,0.704,0.272c0.276,0,0.542-0.092,0.729-0.313
c0.385-0.397,0.373-1.009-0.023-1.394l-3.232-3.136c-0.399-0.384-1.01-0.375-1.399,0.025c-0.386,0.423-0.372,1.044,0.025,1.429
L47.795,36.564z"></path>
<path fill="#E35640" d="M58.141,33.536c-0.02-0.055-0.063-0.092-0.104-0.138c-0.825-3.375-3.223-6.433-5.751-8.039
c-6.093-3.942-13.747-3.708-22.092,0.567c-0.858,0.438-1.686,0.95-2.51,1.423c-1.615,0.905-3.104,1.8-4.769,2.365
c-0.647,0.24-1.262,0.434-1.911,0.662c-2.199,0.733-4.466,1.491-6.665,2.672c-3.404,1.849-5.602,4.577-6.007,7.519
c-0.064,0.538-0.061,1.044-0.027,1.551c-0.07,0.178-0.117,0.329-0.107,0.535c0.263,3.821,2.221,7.568,4.987,9.528
c2.579,1.826,7.356,3.68,16.092,3.678c2.99,0,6.436-0.232,10.437-0.725c0.258-0.032,0.484-0.057,0.604-0.069
c14.671-1.535,17.092-9.001,17.876-11.47C59.233,40.391,59.775,37.93,58.141,33.536z M10.351,40.855
c0.449-3.27,3.605-5.296,4.965-6.025c2.021-1.106,4.211-1.838,6.336-2.548c0.622-0.194,1.283-0.427,1.941-0.671
c1.853-0.621,3.488-1.597,5.075-2.506c0.83-0.497,1.637-0.955,2.464-1.38c4.087-2.12,7.948-3.155,11.495-3.155
c3.135,0,5.994,0.828,8.566,2.465c2.939,1.882,5.618,6.05,5.056,9.772c-1.022,6.47-7.458,9.083-13.422,11.048
c-5.647,1.811-11.747,2.061-16.458,2.061c-1.324,0-2.679-0.019-3.999-0.044c-3.587-0.067-6.327-0.769-8.428-2.141
C11.874,46.396,9.945,43.742,10.351,40.855z M40.129,53.037c-0.164,0.014-0.372,0.042-0.682,0.112
c-15.018,1.903-21.924-0.359-25.104-2.597c-0.317-0.237-0.587-0.506-0.88-0.755c2.309,1.307,5.222,2.005,8.838,2.073
c1.364,0.025,2.732,0.044,4.068,0.044c4.845,0,11.167-0.221,17.091-2.141c5.146-1.704,10.657-3.895,13.311-8.498
c-0.128,0.538-0.317,1.108-0.489,1.728C55.585,45.118,53.474,51.663,40.129,53.037z"></path>
<path fill="#E35640" d="M21.922,45.75c3.225,0,5.838-2.091,5.838-4.607c0-2.556-2.613-4.646-5.838-4.646
c-3.193,0-5.808,2.091-5.808,4.646C16.114,43.659,18.729,45.75,21.922,45.75z M21.922,38.534c2.079,0,3.833,1.187,3.833,2.608
c0,1.383-1.754,2.608-3.833,2.608c-2.049,0-3.809-1.226-3.809-2.608C18.113,39.721,19.873,38.534,21.922,38.534z"></path>
<path fill="#E35640" d="M28.578,44.873c-0.392,0.392-0.392,1.002,0,1.393l1.694,1.698c0.181,0.176,0.45,0.303,0.695,0.303
c0.256,0,0.525-0.127,0.702-0.303c0.391-0.391,0.391-1.04,0-1.432l-1.659-1.659C29.619,44.468,28.97,44.468,28.578,44.873z"></path>
<path fill="#E35640" d="M50.088,32.374c0.216,0.215,0.479,0.303,0.717,0.303c0.27,0,0.537-0.088,0.716-0.303
c0.392-0.392,0.392-1.001,0-1.394l-3.147-3.186c-0.392-0.392-1.04-0.392-1.432,0c-0.391,0.392-0.391,1.04,0,1.432L50.088,32.374z"></path>
</g>
                </svg>
                <span className='categoryName'>
                    MEAT
                </span>
            </Link>
            </div>
        </div>
        <div className='row text-center'>
            <div className='col backwards'>
            <Link to={`/recipes/drinks`} style={{textDecoration: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="58px" viewBox="0 0 66 58" enableBackground="new 0 0 66 58">
<path fill="#E35640" d="M53.438,13.548c0.28-0.303,0.343-0.723,0.197-1.089c-0.184-0.365-0.545-0.615-0.94-0.615h-8.469l3.813-6.667
c0.288-0.472,0.098-1.097-0.372-1.349C47.193,3.54,46.565,3.69,46.28,4.201l-4.368,7.643H14.764c-0.397,0-0.76,0.25-0.904,0.615
c-0.143,0.366-0.082,0.786,0.158,1.089l18.71,20.51v18.979h-8.578c-0.536,0-0.98,0.443-0.98,0.98c0,0.576,0.444,1.019,0.98,1.019
h19.156c0.577,0,1.02-0.442,1.02-1.019c0-0.537-0.442-0.98-1.02-0.98h-8.54V34.058L53.438,13.548z M35.281,28.002
c-1.385,0-2.502-1.116-2.502-2.475c0-1.374,1.117-2.492,2.502-2.492c1.386,0,2.503,1.118,2.503,2.492
C37.784,26.886,36.667,28.002,35.281,28.002z M39.78,25.572c0-0.012,0.004-0.021,0.004-0.045c0-1.332-0.603-2.507-1.501-3.324
l1.849-3.234h5.646L39.78,25.572z M43.073,13.844h7.345l-2.802,3.127h-6.332L43.073,13.844z M19.892,16.985l-2.816-3.142h23.683
l-1.786,3.127h-19.01C19.937,16.971,19.917,16.983,19.892,16.985z M33.747,32.175L21.718,18.969h16.102l-1.308,2.244
c-0.395-0.104-0.802-0.178-1.23-0.178c-2.496,0-4.502,2.006-4.502,4.492c0,2.47,2.006,4.474,4.502,4.474
c0.146,0,0.325-0.027,0.468-0.043L33.747,32.175z"></path>
                </svg>
                <span className='categoryName'>
                    DRINKS
                </span>
            </Link>    
            </div>
            <div className='col backwards2'>
            <Link to={`/recipes/desserts`} style={{textDecoration: 'none'}}>
                <svg  style={{position: 'relative', bottom: '10px'}} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="58px" viewBox="0 0 66 58" enableBackground="new 0 0 66 58">
<path fill="#E35640" d="M54.465,34.375c-0.211-0.34-1.277-2.076-3.772-3.882c-2.667-1.906-4.348-2.333-4.51-2.381
c-0.169-0.033-0.295-0.031-0.415-0.008c-0.004,0-0.008,0-0.01,0c0-0.019,0.006-0.036,0.006-0.055c0-2.83-2.061-5.19-4.739-5.695
c0.308-1.721,1.26-3.33,2.737-4.271c0.496-0.303,0.62-0.923,0.312-1.389c-0.307-0.471-0.902-0.611-1.401-0.307
c-2.018,1.301-3.328,3.564-3.643,5.949c-2.79,0.442-4.889,2.828-4.889,5.713c0,0.736,0.136,1.436,0.399,2.082l-22.201,4.074
c-0.223,0.034-0.37,0.145-0.533,0.275c-0.251,0.18-0.462,0.482-0.462,0.838V54.79c0,0.555,0.44,1.014,1.015,1.017l41.373,0.219
c0.002,0,0.004,0,0.005,0c0.268,0,0.506-0.112,0.715-0.299c0.169-0.189,0.271-0.441,0.271-0.71v-19.96
C54.722,34.804,54.623,34.562,54.465,34.375z M13.344,39.336h39.373v4.48c-1.126,1.291-3.131,2.205-4.818,1.41
c-0.378-0.179-0.761-0.449-1.163-0.737c-0.901-0.653-1.954-1.393-3.324-1.258c-1.095,0.098-1.96,0.642-2.733,1.126
c-0.336,0.203-0.671,0.408-1.02,0.57c-1.074,0.502-1.89,0.231-3.26-0.566l-0.295-0.168c-0.906-0.528-1.834-1.078-3.05-0.949
c-1.259-0.127-2.163,0.422-3.05,0.949l-0.295,0.168c-1.409,0.797-2.209,1.07-3.299,0.566c-0.349-0.162-0.684-0.367-1.017-0.57
c-0.776-0.484-1.641-1.028-2.736-1.126c-1.324-0.136-2.384,0.604-3.324,1.258c-0.401,0.288-0.785,0.559-1.163,0.737
c-1.653,0.803-3.704-0.122-4.826-1.418V39.336z M52.717,36.078v1.242H13.344v-1.006L52.717,36.078z M13.344,46.45
c1.038,0.665,2.241,1.097,3.506,1.097c0.741-0.002,1.487-0.156,2.182-0.5c0.55-0.25,1.014-0.591,1.463-0.92
c0.729-0.511,1.343-0.965,1.988-0.897c0.601,0.067,1.227,0.443,1.885,0.839c0.381,0.234,0.774,0.477,1.201,0.682
c2.025,0.955,3.671,0.208,5.154-0.646l0.266-0.173c0.889-0.498,1.354-0.755,1.906-0.677c0.119,0.014,0.199,0.014,0.279,0
c0.595-0.085,1.057,0.178,1.904,0.676l0.307,0.174c1.481,0.854,3.088,1.604,5.154,0.646c0.427-0.204,0.819-0.447,1.201-0.681
c0.66-0.396,1.247-0.772,1.885-0.84c0.629-0.06,1.221,0.386,1.949,0.897c0.449,0.329,0.952,0.67,1.472,0.92
c1.923,0.915,4.046,0.461,5.671-0.604v4.364H13.344V46.45z M38.984,24.395c0.05,0.458,0.129,0.91,0.252,1.359
c0.156,0.429,0.554,0.71,0.978,0.71c0.088,0,0.177-0.017,0.304-0.051c0.517-0.159,0.822-0.722,0.638-1.249
c-0.066-0.248-0.103-0.49-0.139-0.732c1.559,0.461,2.708,1.902,2.708,3.618c0,2.091-1.683,3.792-3.793,3.792
c-2.079,0-3.791-1.701-3.791-3.792C36.141,26.296,37.338,24.827,38.984,24.395z M39.932,33.858c2.459,0,4.521-1.513,5.37-3.649
l0.526-0.1c0.374,0.12,1.681,0.598,3.697,2.025c0.958,0.695,1.672,1.373,2.165,1.934l-28.413,0.174l12.407-2.273
C36.754,33.121,38.262,33.858,39.932,33.858z M13.344,53.794v-0.97h39.373v1.18L13.344,53.794z"></path>
                </svg>
                <span className='categoryName'>
                    DESSERTS
                </span>
            </Link>
            </div>
        </div>
        <div className='row text-center'>
            <div className='col'>
            <Link to={`/recipes/mainDish`} style={{textDecoration: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="58px" viewBox="0 0 66 58" enableBackground="new 0 0 66 58">
<g>
<path fill="#E35640" d="M56.845,6.834c-0.494-0.305-1.094-0.173-1.404,0.288l-8.604,13.117c-0.704-0.509-1.444-0.949-2.217-1.338
c0.023-0.058,0.055-0.109,0.07-0.163l3.743-12.981c0.175-0.536-0.139-1.094-0.692-1.251c-0.526-0.155-1.067,0.158-1.237,0.695
l-3.728,12.919c-1.657-0.594-3.457-0.929-5.33-0.929c-4.858,0-8.965,1.86-11.932,5.354c-1.25-0.514-2.64-0.798-4.089-0.798
c-5.978,0-10.89,4.877-10.899,10.875H9.827c-0.271,0-0.541,0.101-0.711,0.292c-0.208,0.193-0.302,0.457-0.3,0.721
C8.898,41.53,13.88,48.987,21.063,52.18v2.78c0,0.553,0.483,1.004,1.02,1.004H42.01c0.577,0,1.02-0.451,1.02-1.004v-2.78
c7.183-3.192,12.165-10.648,12.278-18.546c0.002-0.264-0.123-0.527-0.294-0.721c-0.207-0.191-0.443-0.292-0.718-0.292h-0.771
c-0.202-4.38-2.125-8.3-5.131-11.097l8.709-13.296C57.417,7.761,57.302,7.135,56.845,6.834z M21.426,23.758
c4.888,0,8.883,3.975,8.895,8.863h-0.839c-0.012-4.427-3.628-8.017-8.056-8.017c-4.396,0-8.011,3.59-8.021,8.017h-0.839
C12.575,27.732,16.531,23.758,21.426,23.758z M42.856,32.621c-0.305-2.716-2.61-4.825-5.41-4.825c-2.385,0-4.432,1.553-5.181,3.707
c-0.082-0.9-0.31-1.763-0.581-2.582c1.344-1.809,3.48-2.883,5.762-2.883c3.771,0,6.868,2.893,7.213,6.583H42.856z M40.855,32.621
h-6.819c0.321-1.604,1.73-2.81,3.41-2.81C39.142,29.812,40.536,31.017,40.855,32.621z M46.695,32.621
c-0.349-4.804-4.364-8.599-9.249-8.599c-2.584,0-4.985,1.082-6.738,2.922c-0.286-0.45-0.556-0.876-0.895-1.277
c1.961-2.088,4.585-3.199,7.633-3.199c5.731,0,10.449,4.496,10.804,10.153H46.695z M26.021,32.621
c-0.01-2.513-2.075-4.548-4.595-4.548c-2.487,0-4.552,2.035-4.563,4.548h-1.458c0.029-3.314,2.737-5.999,6.021-5.999
c3.316,0,6.003,2.685,6.018,5.999H26.021z M23.982,32.621h-5.081c0.012-1.405,1.148-2.54,2.524-2.54
C22.834,30.081,23.973,31.216,23.982,32.621z M23.103,53.946v-1.244h17.918v1.244H23.103z M41.397,50.688H22.723
c-6.491-2.497-11.333-9.119-11.867-16.059h42.382C52.741,41.571,47.897,48.191,41.397,50.688z M51.486,32.621h-1.239
c-0.354-6.766-5.958-12.168-12.801-12.168c-3.623,0-6.723,1.317-9.064,3.789c-0.327-0.261-0.674-0.508-1.027-0.74
c2.57-2.842,5.952-4.303,10.092-4.303C44.986,19.198,51.13,25.161,51.486,32.621z"></path>
<path fill="#E35640" d="M12.61,38.206c0.729,2.717,2.164,5.203,4.127,7.209c0.179,0.199,0.448,0.295,0.72,0.295
c0.261,0,0.497-0.093,0.712-0.285c0.394-0.39,0.397-1.032,0.008-1.431c-1.743-1.746-2.979-3.933-3.631-6.306
c-0.128-0.537-0.701-0.859-1.222-0.713C12.767,37.12,12.479,37.672,12.61,38.206z"></path>
<path fill="#E35640" d="M20.586,48.69c0.199,0.135,0.386,0.194,0.61,0.194c0.316,0,0.591-0.138,0.807-0.409
c0.332-0.444,0.244-1.079-0.233-1.403l-1.391-1.04c-0.478-0.329-1.079-0.228-1.413,0.216c-0.333,0.455-0.245,1.083,0.195,1.413
L20.586,48.69z"></path>
</g>
                </svg>
                <span className='categoryName'>
                    MAIN DISH
                </span>
            </Link>
            </div>
            <div className='col backwards2'>
            <Link to={`/recipes/cereals`} style={{textDecoration: 'none'}}>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="66px" height="47.61px" viewBox="0 0 66 47.61" enableBackground="new 0 0 66 47.61">
<g>
<path className="cereal-svg" style={{fill: 'none'}} fill="none"strokeWidth="2" d="
M44.751,29.223c-2.295,4.002-6.793,4.796-9.929,7.932c-1.712,1.716-1.943,4.172-1.976,8.002c-0.032-3.83-0.265-6.286-1.976-8.002
c-3.135-3.136-7.621-3.93-9.915-7.932c0,0-0.298,9.9,1.983,13.881c2.259,3.943,9.763,3.965,9.9,3.965l0,0h0.007h0.007l0,0
c0.137,0,7.654-0.021,9.915-3.965C45.05,39.123,44.751,29.223,44.751,29.223z"></path>
<path className="cereal-svg" style={{fill: 'none'}} fill="none"strokeWidth="2" d="
M44.616,23.756c0.209-2.973,0.135-5.447,0.135-5.447c-1.146,2.002-2.845,3.203-4.647,4.291c-1.805,1.092-3.712,2.072-5.281,3.641
c-0.855,0.855-1.341,1.896-1.617,3.206c-0.276,1.308-0.342,2.88-0.358,4.794c-0.014-1.914-0.082-3.486-0.357-4.794
c-0.277-1.31-0.764-2.351-1.618-3.206c-1.569-1.568-3.473-2.549-5.274-3.641c-1.799-1.088-3.494-2.289-4.641-4.291
c0,0-0.073,2.475,0.136,5.447"></path>
<path className="cereal-svg" style={{fill: 'none'}} fill="none" strokeWidth="2" d="
M44.616,12.84c0.209-2.972,0.135-5.447,0.135-5.447c-1.146,2.003-2.845,3.203-4.647,4.291c-1.805,1.092-3.712,2.072-5.281,3.641
c-0.855,0.856-1.341,1.897-1.617,3.207c-0.276,1.307-0.342,2.88-0.358,4.795c-0.014-1.915-0.082-3.488-0.357-4.795
c-0.277-1.31-0.764-2.351-1.618-3.207c-1.569-1.568-3.473-2.549-5.274-3.641c-1.799-1.088-3.494-2.288-4.641-4.291
c0,0-0.073,2.476,0.136,5.447"></path>
<line x1="32.854" y1="47.068" x2="32.854" y2="55"></line>
</g>
                </svg>
                <span className='categoryName'>
                    CEREALS
                </span>
            </Link>
            </div>
        </div>
        <div className='row marginTopHr'>
            <hr/>
        </div>
    </div>
    </div>
  )
}
